import { Component, Input, OnInit } from '@angular/core';
import { Organisation } from 'src/app/models/organisation';

@Component({
  selector: 'app-settingsAccountSecurityWebauthnList',
  templateUrl: './settings-account-security-webauthn-list.component.html'
})
export class SettingsAccountSecurityWebauthnListComponent implements OnInit {

  private _organisation!: Organisation;
  errorMessage!: string;
  defaultError: boolean = true;
  get organisation(): Organisation {
    return this._organisation;
  }  
  @Input('Organisation') set organisation(val: Organisation){
    this._organisation =val
  }
  devices: any[] = [{Name:"Macbook Pro van Tom", Date:"14-07-2023"}, {Name:"Laptop van Tom", Date:"14-07-2023"}, {Name:"iPhone van Tom", Date:"14-07-2023"}];

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  removeDevice(index: number) {
    this.devices.splice(index, 1);
  }
  
}